import h from "trader-hyperscript";
import { Source } from "trader.ts/types/source";
import { scheduleForCleanup } from "trader.ts/ui";
import * as style from "./../../styles/style.css.classes";

export function checkbox(opts: {
  source: Source<boolean>;
  label: string;
  class?: string;
}): HTMLElement {
  const i = (
    <input
      type="checkbox"
      onchange={(e: InputEvent) =>
        opts.source.set((e?.target as HTMLInputElement)?.checked)
      }
    />
  ) as HTMLInputElement;

  i.checked = opts.source.get() ? true : false;

  scheduleForCleanup(
    opts.source.observe((checked) => (i.checked = checked ? true : false)),
  );

  return (
    <div className={opts.class || style.checkbox}>
      {i} {opts.label}
    </div>
  );
}
